import { render, staticRenderFns } from "./ProductSpecifications.vue?vue&type=template&id=737943de&scoped=true"
import script from "./ProductSpecifications.vue?vue&type=script&lang=js"
export * from "./ProductSpecifications.vue?vue&type=script&lang=js"
import style0 from "./ProductSpecifications.vue?vue&type=style&index=0&id=737943de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737943de",
  null
  
)

export default component.exports